import React, { useContext, useEffect, useRef, useState, useSyncExternalStore } from "react";
import ServiceContext from "../WebService/ServiceContext";
import { BasicContext } from '../context/BasicContext'
import AnswerBtns from './AnswerBtns'
import FileUploader from './FileUploader'
import Questionnaire from "./Questionnaire";

import { HibModal } from "./HibModal";
import ImgLoader from './ImgLoader'
import AnswerInput from "./AnswerInput";
import { createElement } from 'react';

import { Close, Spinner } from './SVG'
import { centroid } from "zrender/lib/tool/morphPath";
import PosterLoader from "./PosterLoader";

// Import Swiper React components

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';


type CardDetailProp = {
    cardData: CardProps | undefined
}


type PerformanceTickets = {
    競賽業績: number,
    金張數: number,
    銀張數: number,
    銅張數: number,
}

const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}

const detectURL = (str: string) => {
    const pattern = new RegExp('(https?:\/\/)?([\da-z\.-]+)\.([a-z1-9\.]{2,6})([\/\w \.-]*)*\/?', 'i');
    const res: RegExpMatchArray = str.match(pattern) as RegExpMatchArray
    if (res) {
        //console.log(str.split("，"))
        return createElement(
            'span',
            null,
            str.split(res[0])[0],
            createElement('a', { href: res[0], target: "_blank" }, res[0]),
            (str.split(res[0])[1] ? str.split(res[0])[1] : null)
        );
        //return str.replace(res[0], `<a href='${res[0]}'>${res[0]}</a>`)
    } else {
        return str
    }


    //return !!pattern.test(str);
}

export default (props: CardDetailProp) => {
    const ws = useContext(ServiceContext)
    const bc = useContext(BasicContext)
    const [EID, setEID] = useState<number | null>()
    const [PT, setPT] = useState<PerformanceTickets | null>()
    const [quests, setQuests] = useState<QuestRes[]>([])
    const [openQuest, setOpenQuest] = useState<boolean>(false)
    const [hasFile, setHasFile] = useState<boolean>(false)

    //const [confirmTxt, setConfirmTxt] = useState<React.HTMLAttributes<HTMLDivElement>>()
    //const [confirmTxt, setConfirmTxt] = useState<string>("")

    const [openReviewConfirm, setOpenReviewConfirm] = useState<boolean>(false)
    const [openConfirm, setOpenConfirm] = useState<boolean>(false)
    const [openNotToAttend, setOpenNotToAttend] = useState<boolean>(false)
    const [openConfirmWithQuest, setOpenConfirmWithQuest] = useState<boolean>(false)
    const [notDone, setNotDone] = useState<boolean>(true)
    const [typeTitle, setTypeTitle] = useState<(string)>("")

    const [nowTime, setNowTime] = useState<(number)>(new Date().getTime())
    const [beginTime, setBeginTime] = useState<(number)>(0)
    const [endTime, setEndTime] = useState<(number)>(0)

    const [modalPhoto, setModalPhoto] = useState<boolean>(false)
    const [swiperIndex, setSwiperIndex] = useState<number>(0);

    const sectionRef = useRef<HTMLDivElement>(null);

    const [openBtn, setOpenBtn] = useState<boolean>(false)

    const closePanel = () => {
        bc.setActID("")
        bc.setOpenCard(false)
        setOpenQuest(false)
        setNotDone(true)
        bc.setAnsList([])
        setOpenConfirm(false)
        setOpenReviewConfirm(false)
        setOpenConfirmWithQuest(false)
        setOpenNotToAttend(false)
        setHasFile(false)
        setOpenBtn(false)
        setQuests([])
        setEID(null)
    }

    const loadData = () => {
        ws.WebService.asyncGetActMainOtsList(bc.Class1).then((res: any) => {
            //console.log(res)
            bc.setCardList(res.Data as CardProps[])
        })
    }

    const gotoOnlineCourse = () => {
        if (props) {
            window.open(`../Ashx/GoOtherSite.ashx?SiteName=eLearning&cid=${props.cardData?.ActID}&IP=0.0.0.0&isComplete=0`, "_blank");
        }
    }

    const LessonDateFormat = (timestamp: string) => {
        const match: string[] = timestamp.match(/Date\((\d+)\)/i) as string[]
        if (match) {
            const _d = new Date(parseInt(match[1]))
            return `
                ${_d.getFullYear()}/${((_d.getMonth() + 1) < 10 ? '0' : '')}${(_d.getMonth() + 1)}/${_d.getDate() < 10 ? '0' : ''}${_d.getDate()} 
                ${_d.getHours() < 10 ? '0' : ''}${_d.getHours()}:${_d.getMinutes() < 10 ? '0' : ''}${_d.getMinutes()}
            `
        } else {
            return " ----/--/-- "
        }
    }

    const AnswerMyQ = (): Promise<boolean> => {
        let sn: number = 0;
        return new Promise((resolve, reject) => {
            const doAnswer = (): boolean => {
                if ((bc.ansList[sn]?.ItemID || bc.ansList[sn]?.ItemTxt) && bc.ansList[sn]?.QSNo && props.cardData?.ExamID) {
                    ws.WebService.asyncAnswerQuestionnaire(
                        props.cardData?.ExamID,
                        props.cardData?.ActID,
                        parseInt(bc.ansList[sn].QSNo),
                        bc.ansList[sn].ItemID ? bc.ansList[sn].ItemID : undefined,
                        bc.ansList[sn].ItemTxt ? bc.ansList[sn].ItemTxt : undefined,
                    ).then(res => {
                        sn++
                        if (bc.ansList.length != sn) {
                            doAnswer()
                        } else {
                            sn = 0
                            resolve(true)
                        }
                    })
                }
                return true
            }

            bc.ansList.length != quests.length ?
                resolve(false)
                :
                doAnswer()
        })
    }

    const checkAnsTotal = () => {
        //let count: number = 0
        let countAry: string[] = []
        bc.ansList.map((item) => {
            if (item.ItemID) {
                countAry.push(item.ItemID)
            } else if (item.ItemTxt) {
                countAry.push(item.ItemTxt)
            }

            //count++
        })
        if (quests.length == countAry.length) {
            setNotDone(false)
        } else {
            setNotDone(true)

        }
    }

    useEffect(() => {
        //bc.setAnswerList([])
        if (props.cardData && bc.openCard) {
            setNowTime(new Date().getTime())
            if (props.cardData && props.cardData.BeginTime) {
                const bt: string[] = props.cardData?.BeginTime?.toString().match(/Date\((\d+)\)/i) as string[]
                setBeginTime(parseInt(bt[1]))
            } else {
                setBeginTime(0)
            }

            if (props.cardData && props.cardData.EndTime) {
                const et: string[] = props.cardData?.EndTime?.toString().match(/Date\((\d+)\)/i) as string[]
                setEndTime(parseInt(et[1]))
            } else {
                setEndTime(0)
            }

            //問卷

            if (props.cardData && props.cardData.ExamID) {
                setEID(props.cardData.ExamID)
                ws.WebService.asyncGetQuestionnaire(props.cardData.ExamID)
                    .then(res => {
                        const QRes = res as QuestRes[]
                        setQuests(QRes)
                        //已經有答題狀態，將修改按鈕打開
                        setNotDone(!(bc.ansList.length == QRes.length))

                        setOpenBtn(true)
                    })
            } else {
                setOpenBtn(true)
            }

            //摸彩券
            /*
            if (props.cardData && props.cardData.ActID && (
                props.cardData.ActID == 'S20230001'
                || props.cardData.ActID == 'ADATEST01'
            )
            ) {a
                ws.WebService.asyncGetPerformanceTickets(112).then(res => {
                    if (res) {
                        setPT(res as PerformanceTickets)
                    }
                })
            } else {
                setPT(null)
            }
            */
            //console.log(props.cardData)

            setOpenQuest([1, 7].indexOf(Number(props.cardData?.regState)) > -1)

            //setNotDone([1, 7].indexOf(Number(props.cardData?.regState)) < -1)
            bc.setActID(props.cardData.ActID)
        }
        return
    }, [props.cardData, bc.openCard])

    useEffect(() => {
        if (bc.openCard && EID && props.cardData?.ActID) {
            ws.WebService.asyncGetAnswer(props.cardData.ActID, EID).then(res => {
                if (res) {
                    bc.setAnsList(res as ResAnswers[])
                }
            })
        }
        return
    }, [EID, bc.openCard])

    useEffect(() => {
        setTypeTitle(bc.Class1 == "A" ? "活動" : bc.Class1 == "B" ? "課程" : "")
    }, [bc.ActType])

    useEffect(() => {
        if (openQuest) {
            const _s = sectionRef.current as HTMLElement
            _s.scrollTo({
                top: 400,
                behavior: "smooth",
            })
        }
    }, [openQuest])

    const timeFormateA = (time: number): string => {
        return `${Math.floor(time / 60)}分`
    }

    const timeFormateB = (time: number, limit: number | null = null): string => {
        if (limit && time > limit) {
            return `${Math.floor(limit * 60)}分`
        } else {
            return `${Math.floor(time * 60)}分`
        }
    }

    return (
        <>
            <div className={"hibModal " + (bc.openCard ? "open" : "")} id="lessonModal" >
                <div className="modalContent">
                    <div className="modalHeader">
                        <button className="close" onClick={closePanel}>
                            <Close />
                        </button>
                        <label className="title">
                            {
                                props.cardData && props.cardData.ActTitle ?
                                    props.cardData.ActTitle :
                                    "尚未設定名稱"
                            }
                        </label>
                    </div>
                    <div className="modalBody" ref={sectionRef}>
                        {
                            props.cardData ?
                                <div>
                                    <div>
                                        <div>
                                            <div>
                                                {
                                                    ["dashboard", "list", "state"].indexOf(bc.PID) > -1 &&
                                                    <div className="photo">
                                                        {
                                                            props.cardData &&
                                                            <ImgLoader ActID={props.cardData.ActID} />
                                                        }
                                                    </div>
                                                }
                                                {
                                                    PT &&
                                                    <section className="PT">
                                                        <div>
                                                            您的<span className="year">111</span>年度業績為：
                                                            <span className="performance">{money(PT.競賽業績)}元</span>，
                                                            <span className="gold">金券{PT.金張數 ? PT.金張數 : 0}張</span>，
                                                            <span className="silver">銀券{PT.銀張數 ? PT.銀張數 : 0}張</span>，
                                                            <span className="bronze">銅券{PT.銅張數 ? PT.銅張數 : 0}張</span>。
                                                        </div>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.hours &&
                                                    props.cardData?.ExamPaper == null &&
                                                    <section >
                                                        <div className="secTitle">課程時數</div>
                                                        <p>{timeFormateB(props.cardData.hours)}</p>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.Hours1 &&
                                                    props.cardData?.ExamPaper == null &&
                                                    <section >
                                                        <div className="secTitle">課程時數</div>
                                                        <p>{timeFormateB(props.cardData.Hours1)}</p>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.WatchHours &&
                                                    props.cardData?.ExamPaper == null &&
                                                    <section >
                                                        <div className="secTitle">觀看時數</div>
                                                        <p>{timeFormateB(props.cardData.WatchHours, props.cardData.Hours1)}</p>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.ExamPaper != null &&
                                                    props.cardData?.ExamScore != null &&
                                                    <section >
                                                        <div className="secTitle">您的分數</div>
                                                        <p>{props.cardData.ExamScore}分</p>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.RecordTime &&
                                                    <section >
                                                        <div className="secTitle">觀看時數</div>
                                                        <p>{timeFormateA(props.cardData.RecordTime)}</p>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.ActDate &&
                                                    <section >
                                                        <div className="secTitle">{typeTitle}時間</div>
                                                        <p>{props.cardData.ActDate}</p>
                                                    </section>
                                                }
                                                {
                                                    props.cardData?.PublishDate &&
                                                    <section >
                                                        <div className="secTitle">上架日期</div>
                                                        <p>
                                                            <span className="from">{LessonDateFormat(props.cardData.PublishDate)}</span>
                                                        </p>
                                                    </section >
                                                }
                                                {
                                                    props.cardData?.BeginTime && props.cardData.EndTime &&
                                                    <section >
                                                        <div className="secTitle">報名起訖日</div>
                                                        <p>
                                                            <span className="from">{LessonDateFormat(props.cardData.BeginTime)}</span> 至
                                                            <span className="to">{LessonDateFormat(props.cardData.EndTime)}</span>
                                                        </p>
                                                    </section >
                                                }
                                                {
                                                    props.cardData?.Location &&
                                                    <section >
                                                        <div className="secTitle">地點</div>
                                                        <p>{props.cardData.Location}</p>
                                                    </section>

                                                }
                                                {
                                                    props.cardData?.Speaker &&
                                                    <section >
                                                        <div className="secTitle">講師</div>
                                                        <p>{props.cardData.Speaker}</p>
                                                    </section>
                                                }

                                                {
                                                    props.cardData?.Remark &&
                                                    <section >
                                                        <div className="secTitle">{typeTitle}備註</div>
                                                        <div className="remark" tabIndex={0} >
                                                            <p>
                                                                <pre>
                                                                    {props.cardData.Remark}
                                                                </pre>
                                                            </p>
                                                        </div>
                                                    </section>
                                                }

                                                {
                                                    props.cardData?.Url &&
                                                    <section className="secTitle">
                                                        <div className="secTitle">網址連結</div>
                                                        <a className="url" href={props.cardData.Url} target="_blank">{props.cardData.Url}</a>
                                                    </section>
                                                }

                                                {
                                                    //20240731 卡片內海報
                                                    props.cardData?.AttachmentPosters &&
                                                    <section >
                                                        <div >
                                                            {
                                                                (JSON.parse(props.cardData.AttachmentPosters) as AttachmentPostersProps[]).map(
                                                                    (item: AttachmentPostersProps, index: number) =>
                                                                        <span onClick={() => {
                                                                            setModalPhoto(true)
                                                                            setSwiperIndex(index)
                                                                        }}>
                                                                            <PosterLoader
                                                                                FPath={item.FPath}
                                                                                imgStyle={{ width: 60, height: 60, margin: 5, objectFit: "cover" }}
                                                                            />
                                                                        </span>
                                                                )}
                                                        </div>
                                                    </section>
                                                }

                                                {
                                                    //正取備取判斷 先不要用
                                                    /*
                                                    props.cardData?.regState != 1 && 
                                                    props.cardData?.acceptNum !=  undefined && 
                                                    props.cardData?.acceptNum !=  0 && 
                                                    props.cardData?.RegTotal - props.cardData?.acceptNum >= 0 &&
                                                    <div style={{width:"100%", textAlign:"center", fontSize:"1.6em", color:"#f30"}}>
                                                        <p >目前報名人數已達正取人數的上限，此次將以備取人數報名參加。</p>
                                                        <p>備取順位：{
                                                            (props.cardData?.RegTotal - props.cardData?.acceptNum )+1
                                                        }</p>
                                                    </div>
                                                    */
                                                }

{
                                                    props.cardData?.RecognizeYear &&
                                                    props.cardData?.ExamPaper == null &&
                                                    <section >
                                                        <div className="secTitle">認列年度</div>
                                                        <p>{ props.cardData.RecognizeYear}</p>
                                                    </section>
                                                }

                                                {
                                                    props.cardData?.ExamPaperList &&
                                                    <section>
                                                        <div className="secTitle">{typeTitle}試卷列表</div>
                                                        <div style={{display:"flex", flexWrap:"wrap"}}>
                                                        {
                                                            JSON.parse(props.cardData.ExamPaperList).map((item: ExamPaperListProps) =>
                                                                <button className="hibBtn main small"
                                                                    onClick={() => {
                                                                        bc.setPID('exam')
                                                                        bc.setExamPaper(item.ExamID.toString())

                                                                    }}
                                                                >{item.ExamName}</button>
                                                            )
                                                        }
                                                        </div>
                                                    </section>
                                                }


                                                {
                                                    ["dashboard", "list"].indexOf(bc.PID) > -1 &&
                                                    <section>
                                                        {
                                                            props.cardData?.NoFilm != true &&
                                                            <button
                                                                className="hibBtn main full large"
                                                                onClick={() => {

                                                                    if (props.cardData?.isComplete == 4) {
                                                                        setOpenReviewConfirm(true)
                                                                    } else {
                                                                        gotoOnlineCourse()
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fas fa-desktop"></i>
                                                                線上課程
                                                            </button>
                                                        }
                                                        {/* 不參考ExamPaper 改使用ExamPaperlist讀取複數卷
                                                            props.cardData?.ExamPaper &&
                                                            <button
                                                                className="hibBtn main full large"
                                                                onClick={() => {
                                                                    //alert("我要測驗啦!!JOJO!!!!")
                                                                    if (props.cardData?.ExamPaper != null) {
                                                                        bc.setPID('exam')
                                                                        bc.setExamPaper(props.cardData.ExamPaper.toString())
                                                                    }
                                                                }}

                                                            >
                                                                <i className="fas fa-desktop"></i>
                                                                測驗卷
                                                            </button>

                                                        */}

                                                    </section>
                                                }




                                                {//需要上傳檔案
                                                    nowTime > beginTime &&
                                                    nowTime < endTime &&
                                                    ["event", "lession"].indexOf(bc.PID) > -1 &&
                                                    props.cardData &&
                                                    props.cardData.needFile == true &&
                                                    [0, 1, 3, 10].indexOf(Number(props.cardData?.regState)) > -1 && //判斷 0:可以報名 1:已報名 3:不參加 10:已取消 的狀態可以填寫資料    
                                                    <section className="secTitle">
                                                        <div className="btns">
                                                            {
                                                                props.cardData.editable == 1 &&
                                                                <FileUploader
                                                                    cardData={props.cardData}
                                                                    complete={() => {
                                                                        setHasFile(true)
                                                                        loadData()
                                                                        //console.log(props.cardData)
                                                                    }}
                                                                />
                                                            }
                                                        </div>
                                                    </section>
                                                }


                                                {
                                                    nowTime > beginTime &&
                                                    nowTime < endTime &&
                                                    ["event", "lession"].indexOf(bc.PID) > -1 &&
                                                    //props.cardData?.needFile == false &&
                                                    [0, 1, 3, 10].indexOf(Number(props.cardData?.regState)) > -1 && //判斷 0:可以報名 1:已報名 3:不參加 10:已取消 的狀態可以填寫資料    
                                                    <section>
                                                        <div className="btns">
                                                            {
                                                                openBtn ?
                                                                    <>
                                                                        {
                                                                            [0].indexOf(Number(props.cardData?.regState)) > -1 ||
                                                                                ([3, 10].indexOf(Number(props.cardData?.regState)) > -1 && props.cardData?.editable == 1) ?
                                                                                <button
                                                                                    className="hibBtn main large long"
                                                                                    disabled={
                                                                                        props.cardData?.needFile == true &&
                                                                                        hasFile == !true
                                                                                    }
                                                                                    onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                                                                        quests.length > 0 ?
                                                                                            props.cardData &&
                                                                                            setOpenQuest(true)
                                                                                            :
                                                                                            props.cardData &&
                                                                                            setOpenConfirm(true)

                                                                                        //20240505新增正取人數警語

                                                                                    }}
                                                                                >{quests.length > 0 ? "填寫問卷並報名" : "我要報名"}</button> : ""
                                                                        }
                                                                        {
                                                                            props.cardData?.notjoin == true &&
                                                                            [0].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                                            <button
                                                                                className="hibBtn main large long red"
                                                                                onClick={() => {
                                                                                    setOpenNotToAttend(true)
                                                                                }}
                                                                            >不參加</button>
                                                                        }
                                                                        {
                                                                            props.cardData?.editable == 1 &&
                                                                            [1].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                                            props.cardData?.editable == 1 &&
                                                                            <button
                                                                                className="hibBtn main large long red"
                                                                                onClick={() => {
                                                                                    setOpenNotToAttend(true)
                                                                                }}
                                                                            >取消報名</button>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <Spinner />
                                                            }
                                                        </div>

                                                    </section>
                                                }

                                                {
                                                    quests && quests.length > 0 && openQuest && props.cardData &&
                                                    <div className="quests">
                                                        <Questionnaire
                                                            quests={quests}
                                                            cardData={props.cardData}
                                                            ansList={bc.ansList}
                                                            isComplete={((complete: boolean) => {
                                                                setNotDone(complete)
                                                            })}
                                                        />

                                                        {
                                                            [0, 3, 10].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                            <button
                                                                className="hibBtn main full large"
                                                                disabled={notDone}
                                                                onClick={() => {
                                                                    setOpenConfirmWithQuest(true)
                                                                }}
                                                            >送出</button>

                                                        }
                                                        {
                                                            (Number(props.cardData?.regState) == 1 && props.cardData?.editable == 1) &&
                                                            <button
                                                                className="hibBtn main full large"
                                                                disabled={notDone}
                                                                onClick={() => {
                                                                    setOpenConfirmWithQuest(true)
                                                                }}
                                                            >修改</button>
                                                        }
                                                    </div>
                                                }
                                                {

                                                    quests && quests.length > 0 && openQuest &&
                                                    <div className="quests" style={{ display: "none" }}>
                                                        <div className="secTitle">問卷調查</div>
                                                        {/*
                                                    quests.map((quest: QuestRes, index: number) => {

                                                        return (
                                                            <div key={"question-" + index}>
                                                                <div className="title">{index + 1}. {detectURL(quest.QName)}</div>
                                                                <div>
                                                                    {
                                                                        quest.QType == 3 ?
                                                                            <AnswerInput
                                                                                qName={quest.QName}
                                                                                isAnswered={
                                                                                    (
                                                                                        [1, 7].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                                                        props.cardData?.editable == 0
                                                                                    ) == true
                                                                                }
                                                                                defAns={bc.ansList[index]?.ItemTxt}
                                                                                //defAns={[1, 7].indexOf(Number(props.cardData?.regState)) > -1 ? quest.defAns : undefined}
                                                                                //showAns={[1, 7].indexOf(Number(props.cardData?.regState)) > -1 ? quest.defAns : undefined}
                                                                                serial={index}
                                                                                QSNo={quest.QSNo}
                                                                                checker={checkAnsTotal}
                                                                            //jsonString={quest.Answers}
                                                                            /> :
                                                                            <AnswerBtns
                                                                                qName={quest.QName}
                                                                                //defAns={[1, 7].indexOf(Number(props.cardData?.regState)) > -1 ? quest.defAns : undefined}
                                                                                defAns={bc.ansList[index]?.ItemID}
                                                                                showAns={
                                                                                    (
                                                                                        [1, 7].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                                                        props.cardData?.editable == 0
                                                                                    ) == true
                                                                                }
                                                                                serial={index}
                                                                                QSNo={quest.QSNo}
                                                                                jsonString={quest.Answers}
                                                                                checker={checkAnsTotal}
                                                                            />
                                                                    }
                                                                </div>
                                                            </div>
                                                        )

                                                    })
                                                */}
                                                        {/*
                                                    notDone &&
                                                    <p style={{ color: "#f30" }}>填寫或修改全部的問卷內容即可送出</p>
                                                */}
                                                        {/*
                                                    [0, 3, 10].indexOf(Number(props.cardData?.regState)) > -1 &&
                                                    <button
                                                        className="hibBtn main full large"
                                                        disabled={notDone}
                                                        onClick={() => {
                                                            setOpenConfirmWithQuest(true)
                                                        }}
                                                    >送出</button>

                                                */}
                                                        {/*
                                                    (Number(props.cardData?.regState) == 1 && props.cardData?.editable == 1) &&
                                                    <button
                                                        className="hibBtn main full large"
                                                        disabled={notDone}
                                                        onClick={() => {
                                                            setOpenConfirmWithQuest(true)
                                                        }}
                                                    >修改</button>
                                                */}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <Spinner />
                        }
                    </div>
                </div>
            </div >

            <HibModal
                type="notice"
                show={openReviewConfirm}
                showCross={true}
                confirm={() => {
                    gotoOnlineCourse()
                    closePanel()
                }}
                cancel={() => {
                    setOpenReviewConfirm(false)
                }}
            >您已經完成本次課程，請問是否重新觀看？此次觀看將不列入課程時數。
            </HibModal>

            <HibModal
                type="notice"
                show={openConfirm}
                showCross={true}
                confirm={() => {
                    if (props.cardData) {
                        ws.WebService.asyncDoApplyCourse(
                            props.cardData.ActID,
                            (
                                (props.cardData.regState == 10 && props.cardData.StateDefault == "N") ? "Y" :
                                    props.cardData.StateDefault == "N" ? "N" :
                                        "Y"
                            )
                        ).then(res => {
                            loadData()
                            closePanel()
                        })
                    }
                }}
                cancel={() => {
                    setOpenConfirm(false)
                }}
            >


                確認是否報名？
                {
                    props.cardData?.editable == 0 &&
                    "一但確認後，恕無法更改！"
                }
            </HibModal>

            <HibModal
                type="notice"
                show={openNotToAttend}
                showCross={true}
                confirm={() => {
                    if (props.cardData) {
                        ws.WebService.asyncDoApplyCourse(
                            props.cardData.ActID,
                            Number(props.cardData?.regState) == 1 ?
                                "C" :
                                "X"
                        ).then(res => {
                            loadData()
                            closePanel()
                        })
                    }
                }}
                cancel={() => {
                    setOpenNotToAttend(false)
                }}
            >
                {
                    Number(props.cardData?.regState) == 1 ?
                        "確認是否取消本次活動?" :
                        "確認是否不參與本次活動?"
                }
            </HibModal>

            <HibModal
                type="notice"
                show={openConfirmWithQuest}
                showCross={true}
                confirm={() => {
                    if (props.cardData) {
                        ws.WebService.asyncDoApplyCourse(
                            props.cardData.ActID,
                            (
                                (props.cardData.regState == 10 && props.cardData.StateDefault == "N") ? "Y" :
                                    props.cardData.StateDefault == "N" ? "N" :
                                        "Y"
                            )
                        ).then(res => {
                            return AnswerMyQ()
                        }).then(res => {
                            if (res) {
                                loadData()
                                closePanel()
                            }
                        })
                    }
                }}
                cancel={() => {
                    setOpenConfirmWithQuest(false)
                }}
            >
                確認是否報名?
                {
                    props.cardData?.editable == 0 &&
                    <p className="warning">
                        一但確認後，恕無法更改！
                    </p>
                }
                {

                    bc.ansList &&
                    bc.ansList.length > 0 &&
                    <div className="confirmAnsList">
                        您的問卷內容
                        {
                            bc.ansList.map((item: ResAnswers, index: number) => {
                                if (item.ItemID && item.ItemID != "") {
                                    return (
                                        <div className="ansList" key={"ansList" + index}>
                                            
                                            <div className="quest">
                                                Q{index + 1}. {item.qtxt}
                                            </div>
                                            <div className="answer">
                                                {item.ansTxt}
                                            </div>
                                        </div>
                                    )
                                }
                                else if (item.ItemTxt) {
                                    return (
                                        <div className="ansList" key={"ansList" + index}>
                                            
                                            <div className="quest">
                                                Q{index + 1}. {item.qtxt}
                                            </div>
                                            <div className="answer">
                                                {item.ItemTxt}
                                            </div>
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                }
            </HibModal>

            {
                /**20240731 卡片內的海報點選彈跳視窗*/
                props.cardData && props.cardData.AttachmentPosters &&
                <HibModal
                    type="photo"
                    show={modalPhoto ? true : false}
                    showCross={true}
                    cancel={() => {
                        setModalPhoto(false)
                    }}
                >
                    <div style={{ width: "100%", height: "calc(100% - 50px)" }}>

                        <Swiper
                            pagination={true}
                            modules={[Pagination]}
                            initialSlide={swiperIndex}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            {

                                (JSON.parse(props.cardData.AttachmentPosters) as AttachmentPostersProps[]).map(
                                    (item: AttachmentPostersProps) =>
                                        <SwiperSlide>
                                            <PosterLoader
                                                imgStyle={{ width: "100%", height: "calc(100% - 50px)", maxHeight: 700, objectFit: "contain" }}
                                                FPath={item.FPath}
                                            />
                                        </SwiperSlide>
                                )}
                        </Swiper>

                    </div>
                </HibModal>
            }
        </>
    )
}

